<template>
  <v-app>
    <v-main>
      <v-container class="mt-16">
        <v-row>
          <v-col cols="12" md="6">
            <div class="header-container">
              <h2 class="section-title">Información de la hipoteca</h2>
              <div class="title-line"></div>
            </div>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Precio de la propiedad</v-label>
                <v-text-field
                    type="number"
                    v-model.number="precio"
                    :prefix="currency"
                    variant="outlined"
                    density="compact"
                    @input="onChange($event)"
                    class="bg-custom"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="col-style">
                <v-row >
                  <v-col cols="7">
                    <v-label class="custom-label">Inicial</v-label>
                    <v-text-field
                        type="number"
                        v-model.number="inicial"
                        :prefix="currency"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                        class="bg-custom"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-label class="custom-label"></v-label>
                    <v-text-field
                        type="number"
                        v-model.number="formattedMortgagePercent"
                        :prefix="percent"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                        readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Plazo del préstamo</v-label>
                <v-select
                    v-model="frequencyOption"
                    :items="itemsFreq"
                    item-title="state"
                    item-value="valorFreq"
                    return-object
                    variant="outlined"
                    density="compact"
                ></v-select>
              </v-col>
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Tasa de Interés</v-label>
                <v-text-field
                    type="number"
                    v-model.number="tasaInteres"
                    :prefix="percent"
                    variant="outlined"
                    density="compact"
                    @input="onChange($event)"
                ></v-text-field>
              </v-col>
            </v-row>
            <div class="header-container">
              <h2 class="section-title">Impuestos y seguros anuales</h2>
              <div class="title-line"></div>
            </div>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" class="col-style">
                <v-row >
                  <v-col cols="7">
                    <v-label class="custom-label">Impuestos</v-label>
                    <v-text-field
                        type="number"
                        v-model.number="impuestos"
                        :prefix="currency"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                        class="bg-custom"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-label class="custom-label"></v-label>
                    <v-text-field
                        type="number"
                        v-model.number="formattedTaxPercent"
                        :prefix="percent"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                        readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="col-style">
                <v-row>
                  <v-col cols="7">
                    <v-label class="custom-label">Seguro</v-label>
                    <v-text-field
                        type="number"
                        v-model.number="seguro"
                        :prefix="currency"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-label class="custom-label"></v-label>
                    <v-text-field
                        type="number"
                        v-model.number="formattedInsurancePercent"
                        :prefix="percent"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                        readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!--<v-row>
              <v-col class="col-style" cols="9">
                <v-text-field :prefix="currency" density="compact" type="number" v-model.number="impuestos"
                              label="Impuestos" variant="outlined" @input="onChange($event)"></v-text-field>
              </v-col>
              <v-col class="col-style">
                <v-text-field class="readonly" density="compact" variant="outlined" readonly>{{
                    taxPercent.toFixed(2)
                  }}{{ percent }}
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="col-style" cols="9">
                <v-text-field :prefix="currency" density="compact" type="number" v-model.number="seguro" label="Seguro"
                              variant="outlined" @input="onChange($event)"></v-text-field>
              </v-col>
              <v-col class="col-style">
                <v-text-field class="readonly" density="compact" variant="outlined" readonly>
                  {{ insurancePercent.toFixed(2) }}{{ percent }}
                </v-text-field>
              </v-col>
            </v-row>-->
            <div class="header-container">
              <h2 class="section-title">Otros costos anuales</h2>
              <div class="title-line"></div>
            </div>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" class="col-style">
                <v-row >
                  <v-col cols="7">
                    <v-label class="custom-label">Asociación (HOA)</v-label>
                    <v-text-field
                        type="number"
                        v-model.number="hoa"
                        :prefix="currency"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                        class="bg-custom"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-label class="custom-label"></v-label>
                    <v-text-field
                        type="number"
                        v-model.number="formattedHoaPercent"
                        :prefix="percent"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                        readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="col-style">
                <v-row>
                  <v-col cols="7">
                    <v-label class="custom-label">Private Mortgage Ins. (PMI)</v-label>
                    <v-text-field
                        type="number"
                        v-model.number="pmi"
                        :prefix="currency"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-label class="custom-label"></v-label>
                    <v-text-field
                        type="number"
                        v-model.number="formattedPmiPercent"
                        :prefix="percent"
                        variant="outlined"
                        density="compact"
                        @input="onChange($event)"
                        readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!--<div>
              <h1 class="titlepie"> OTROS COSTOS </h1>
              <v-divider class="monthly-payment-line-title"></v-divider>
            </div>
            <v-row>
              <v-col class="col-style" cols="9">
                <v-text-field :prefix="currency" density="compact" type="number" v-model.number="hoa"
                              label="Asociasión (HOA)" variant="outlined" @input="onChange($event)"></v-text-field>
              </v-col>
              <v-col class="col-style">
                <v-text-field class="readonly" density="compact" variant="outlined" readonly>{{
                    hoaPercent.toFixed(2)
                  }}{{ percent }}
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="mortgagePercent < 20">
              <v-col class="col-style" cols="9">
                <v-text-field :prefix="currency" density="compact" type="number" v-model.number="pmi"
                              label="Private Mortgage Insurace (PMI)" variant="outlined"
                              @input="onChange($event)"></v-text-field>
              </v-col>
              <v-col class="col-style">
                <v-text-field class="readonly" density="compact" variant="outlined" readonly>{{
                    pmiPercent.toFixed(2)
                  }}{{ percent }}
                </v-text-field>
              </v-col>
            </v-row>-->

            <div class="header-container">
              <h2 class="section-title">Pagos adicionales mensuales</h2>
              <div class="title-line"></div>
            </div>
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="col-style">
                <v-label class="custom-label">Pago Adicional</v-label>
                <v-text-field
                    type="number"
                    v-model.number="pagoAdicional"
                    :prefix="currency"
                    variant="outlined"
                    density="compact"
                    @input="onChange($event)"
                    class="bg-custom"
                ></v-text-field>
              </v-col>
            </v-row>

            <!--<div>
              <h1 class="titlepie"> PAGO ADICIONAL </h1>
              <v-divider class="monthly-payment-line-title"></v-divider>
            </div>
            <v-row>
              <v-col class="col-style">
                <v-text-field :prefix="currency" density="compact" type="number" v-model.number="pagoAdicional"
                              label="Pago Adicional" variant="outlined" @input="onChange($event)"></v-text-field>
              </v-col>
            </v-row>-->
          </v-col>
          <v-col cols="12" md="6">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="col-style">
                <div class="results-container">
                  <div class="result-item">
                    <span class="result-label">Préstamo</span>
                    <span class="result-value">{{ currency }}{{ formattedNumber(prestamo.toFixed(2)) }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">Interés Total</span>
                    <span class="result-value">{{ currency }}{{
                        formattedNumber(interesTotal.toFixed(2))
                      }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">Costo Total</span>
                    <span class="result-value">{{ currency }}{{
                        formattedNumber(costoTotal.toFixed(2))
                      }}</span>
                  </div>
                  <div class="result-item" v-if="pagoAdicional > 0">
                    <span class="result-label">Interés Ahorrado</span>
                    <span class="result-value">{{ currency }}{{
                        formattedNumber(this.interesAhorrado.toFixed(2))
                      }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">Plazo</span>
                    <span class="result-value">
                        <template v-if="plazo > 0">
                            {{ formattedNumber(this.plazo) }} Años y
                        </template>
                        {{ formattedNumber(this.mesesRestantes) }} Meses
                    </span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <hr class="my-12">

        <!-- COLUMNA 2 -->
        <v-row>
          <v-col cols="12" md="6">
            <h1 class="titlepie"> Pago Mensual </h1>
            <v-divider class="monthly-payment-line-title"></v-divider>
            <div id="chartdiv" style="width: 100%; height: 400px;"></div>
          </v-col>
          <v-col cols="12" md="6">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="col-style">
                <div class="results-container">
                  <div class="result-item" v-if="tasaInteres > 0">
                    <span class="result-label">Pago Mensual</span>
                    <span class="result-value">{{ currency }}{{ formattedNumber(this.monthlyPayment.toFixed(2)) }}</span>
                  </div>
                  <div class="result-item" v-if="tasaInteres > 0">
                    <span class="result-label">Principal + Interés</span>
                    <span class="result-value">{{ currency }}{{
                        formattedNumber(this.principal.toFixed(2))
                      }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">Impuestos</span>
                    <span class="result-value">{{ currency }}{{
                        formattedNumber(this.tax.toFixed(2))
                      }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">Seguro</span>
                    <span class="result-value">{{ currency }}{{
                        formattedNumber(this.insurance.toFixed(2))
                      }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">HOA</span>
                    <span class="result-value">{{ currency }}{{
                        formattedNumber(this.hoaRes.toFixed(2))
                      }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">PMI</span>
                    <span class="result-value">{{ currency }}{{
                        formattedNumber(this.pmiRes.toFixed(2))
                      }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <!--<v-col cols="12" md="6">
            <v-row v-if="tasaInteres > 0" class="px-md-10">
              <v-col cols="12" class="calculator-investment">
                <div class="monthly-payment-mount">{{ currency }}{{
                    formattedNumber(this.monthlyPayment.toFixed(2))
                  }}
                </div>
                <v-divider class="monthly-payment-line"></v-divider>
                <h1 class="monthly-payment-title">Pago Mensual</h1>
              </v-col>
            </v-row>
            <v-row v-if="tasaInteres > 0" class="px-md-10">
              <v-col cols="12" class="calculator-investment">
                <div class="monthly-payment-mount">{{ currency }}{{ formattedNumber(this.principal.toFixed(2)) }}</div>
                <v-divider class="monthly-payment-line"></v-divider>
                <h1 class="monthly-payment-title">Principal + Interés</h1>
              </v-col>
            </v-row>
            <v-row class="px-md-10">
              <v-col cols="12" class="calculator-investment">
                <div class="monthly-payment-mount">{{ currency }}{{ formattedNumber(this.tax.toFixed(2)) }}</div>
                <v-divider class="monthly-payment-line"></v-divider>
                <h1 class="monthly-payment-title">Impuestos</h1>
              </v-col>
            </v-row>
            <v-row class="px-md-10">
              <v-col cols="12" class="calculator-investment">
                <div class="monthly-payment-mount">{{ currency }}{{ formattedNumber(this.insurance.toFixed(2)) }}</div>
                <v-divider class="monthly-payment-line"></v-divider>
                <h1 class="monthly-payment-title">Seguro</h1>
              </v-col>
            </v-row>
            <v-row class="px-md-10">
              <v-col cols="12" class="calculator-investment">
                <div class="monthly-payment-mount">{{ currency }}{{ formattedNumber(this.hoaRes.toFixed(2)) }}</div>
                <v-divider class="monthly-payment-line"></v-divider>
                <h1 class="monthly-payment-title">HOA</h1>
              </v-col>
            </v-row>
            <v-row v-if="mortgagePercent < 20" class="px-md-10">
              <v-col cols="12" class="calculator-investment">
                <div class="monthly-payment-mount">{{ currency }}{{ formattedNumber(this.pmiRes.toFixed(2)) }}</div>
                <v-divider class="monthly-payment-line"></v-divider>
                <h1 class="monthly-payment-title">PMI</h1>
              </v-col>
            </v-row>
          </v-col>-->
        </v-row>

        <hr class="my-12">

        <!-- Columna 4 Amortizaciones -->
        <v-row>
          <v-col cols="12">
            <h1 class="titlepie"> Amortización </h1>
            <v-divider class="monthly-payment-line-title"></v-divider>
            <div id="barchartdiv" style="width: 100%; height: 500px;"></div>
          </v-col>
        </v-row>

        <hr class="my-12">

        <!-- Columna 5 Balance  -->
        <v-row>
          <v-col cols="12">
            <h1 class="titlepie"> Balances </h1>
            <v-divider class="monthly-payment-line-title"></v-divider>
            <div id="barchartdivBalance" style="width: 100%; height: 500px;"></div>
          </v-col>
        </v-row>

        <hr class="my-12">

        <!-- COLUMNA 3 -->
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-tabs class="tabtext" v-model="tab">
                <v-tab value="anualizado">Crecimiento Anualizado</v-tab>
                <v-tab value="mensual">Tabla Mensual</v-tab>
              </v-tabs>
              <v-card-text>
                <v-window v-model="tab">
                  <v-window-item value="anualizado">
                    <v-table fixed-header class="w-100" height="580px">
                      <thead>
                      <tr>
                        <th class="text-left">Año</th>
                        <th class="text-left">Principal</th>
                        <th class="text-left">Principal Total</th>
                        <th class="text-left">Interés</th>
                        <th class="text-left">Interés Total</th>
                        <th class="text-left">Balance</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in tablaAnualizada" :key="item.name">
                        <td>{{ item.year }}</td>
                        <td>{{ formattedNumber(item.principal) }}</td>
                        <td>{{ formattedNumber(item.principal_total) }}</td>
                        <td>{{ formattedNumber(item.interes) }}</td>
                        <td>{{ formattedNumber(item.interes_total) }}</td>
                        <td>{{ formattedNumber(item.balance) }}</td>
                      </tr>
                      </tbody>
                    </v-table>
                  </v-window-item>
                  <v-window-item value="mensual">
                    <v-table fixed-header class="w-100" height="580px">
                      <thead>
                      <tr>
                        <th class="text-left">Mes</th>
                        <th class="text-left">Principal</th>
                        <th class="text-left">Principal Total</th>
                        <th class="text-left">Interés</th>
                        <th class="text-left">Interés Total</th>
                        <th class="text-left">Balance</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in tablaMensual" :key="item.name">
                        <td>{{ formattedNumber(item.mes) }}</td>
                        <td>{{ formattedNumber(item.principal) }}</td>
                        <td>{{ formattedNumber(item.principal_total) }}</td>
                        <td>{{ formattedNumber(item.interes) }}</td>
                        <td>{{ formattedNumber(item.interes_total) }}</td>
                        <td>{{ formattedNumber(item.balance) }}</td>
                      </tr>
                      </tbody>
                    </v-table>
                  </v-window-item>
                </v-window>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: 'App',

  data() {
    return {
      percent: "%",
      currency: "$",
      validationError: false,
      frequency: 0,
      frequencyOption: {state: '30 Años (Tasa Fija)', valorFreq: 30},
      itemsFreq: [
        {state: '15 Años (Tasa Fija)', valorFreq: 15},
        {state: '20 Años (Tasa Fija)', valorFreq: 20},
        {state: '30 Años (Tasa Fija)', valorFreq: 30},
      ],
      mortgagePercent: 0,
      precio: 0,
      inicial: 0,
      tasaInteres: 0,
      impuestos: 0,
      seguro: 0,
      insurancePercent: 0,
      taxPercent: 0,
      hoa: 0,
      hoaPercent: 0,
      pmi: 0,
      pmiPercent: 0,
      pagoAdicional: 0,
      prestamo: 0,
      principalSPA: 0,
      interes: 0,
      intereses: 0,
      principal: 0,
      monthQuantity: 0,
      monthlyPayment: 0,
      interesTabla: 0,
      tax: 0,
      insurance: 0,
      hoaRes: 0,
      pmiRes: 0,
      principalTabla: 0,
      principalTotal: 0,
      interesTotal: 0,
      balance: 0,
      frequencyCounter: 0,
      yearsCounter: 0,
      costoTotal: 0,
      mesesRestantes: 0,
      mesCounter: 0,
      plazo: 0,
      meses: 0,
      interesAhorrado: 0,
      tab: null,
      tablaMensual: [],
      tablaAnualizada: [],
      chartData: [],
      chartAmortizacionData: [],
      chartBalanceData: [],
    };
  },
  watch: {
    frequencyOption: function () {
      this.onChange();
    },
  },
  computed: {
    formattedMortgagePercent: {
      get() {
        return this.mortgagePercent.toFixed(2);
      },
      set(value) {
        this.mortgagePercent = parseFloat(value) || 0;
      }
    },
    formattedTaxPercent: {
      get() {
        return this.taxPercent.toFixed(2);
      },
      set(value) {
        this.taxPercent = parseFloat(value) || 0;
      }
    },
    formattedInsurancePercent: {
      get() {
        return this.insurancePercent.toFixed(2);
      },
      set(value) {
        this.insurancePercent = parseFloat(value) || 0;
      }
    },
    formattedHoaPercent: {
      get() {
        return this.hoaPercent.toFixed(2);
      },
      set(value) {
        this.hoaPercent = parseFloat(value) || 0;
      }
    },
    formattedPmiPercent: {
      get() {
        return this.pmiPercent.toFixed(2);
      },
      set(value) {
        this.pmiPercent = parseFloat(value) || 0;
      }
    }
  },
  methods: {
    onChange() {
      if (
          this.precio !== "" &&
          this.inicial !== "" &&
          this.monthlyPayment !== "" &&
          this.pagoAdicional !== ""
      ) {
        this.validationError = false
        this.calculate();
      } else {
        this.validationError = true
      }
    },
    calculate() {
      const currentDate = new Date();
      let actYear = currentDate.getFullYear();
      this.plazo = 0;
      this.meses = 0;
      const frequency = parseFloat(this.frequencyOption.valorFreq);
      const monthQuantity = frequency * 12;
      this.mortgagePercent = (this.inicial / this.precio) * 100;
      this.taxPercent = (this.impuestos / this.precio) * 100;
      this.insurancePercent = (this.seguro / this.precio) * 100;
      this.hoaPercent = (this.hoa / this.precio) * 100;
      this.pmiPercent = (this.pmi / this.precio) * 100;
      this.prestamo = this.precio - this.inicial;
      const intereses = this.tasaInteres / 100;
      this.principalSPA = (this.prestamo) * (intereses / 12) / (1 - Math.pow(1 + intereses / 12, (frequency * (-12))));
      this.principal = (this.prestamo) * (intereses / 12) / (1 - Math.pow(1 + intereses / 12, (frequency * (-12)))) + this.pagoAdicional;
      this.tax = this.impuestos / 12;
      this.insurance = this.seguro / 12;
      this.hoaRes = this.hoa / 12;
      this.pmiRes = this.pmi / 12;
      this.monthlyPayment = this.principal + this.tax + this.insurance + this.hoaRes + this.pmiRes;
      let principalTabla = 0;
      let principalTotal = 0;
      let interesTotal = 0;
      let balance = 0;
      let interes = 0;
      let interesB = 0;
      let interesC = 0;
      this.tablaMensual = [];
      this.tablaAnualizada = [];
      this.chartAmortizacionData = [];
      this.chartBalanceData = [];
      interes = this.prestamo * intereses / 12;
      interesTotal = interes;
      this.interesAhorrado = 0;
      principalTabla = this.principal - interes;
      principalTotal = principalTabla;
      balance = this.prestamo - principalTabla;
      let frequencyCounter = 1;
      let yearsCounter = 0;
      this.mesCounter = 0;
      let acumuladoPrincipal = 0;
      let acumuladoInteres = 0;
      let principalTablaB = this.principalSPA - interes;
      let principalTotalB = principalTablaB;
      let balanceB = this.prestamo - principalTablaB;
      let interesTotalSPA = interes;
      if (this.pagoAdicional > 0) {
        for (let index = 1; index <= monthQuantity; index++) {
          interesC = balanceB * (intereses / 12);
          interesTotalSPA = interesC + interesTotalSPA;
          principalTablaB = this.principalSPA - interesC;
          principalTotalB = principalTablaB + principalTotalB;
          balanceB = balanceB - principalTablaB;
        }
      }
      for (let index = 1; index <= monthQuantity; index++) {
        if (index === 1) {
          frequencyCounter = 1;
          this.tablaMensual.push({
            mes: 1,
            principal: principalTabla.toFixed(2),
            principal_total: principalTotal.toFixed(2),
            interes: interes.toFixed(2),
            interes_total: interesTotal.toFixed(2),
            balance: balance.toFixed(2)
          });
          acumuladoPrincipal = principalTabla;
          acumuladoInteres = interes;
        } else if (balance >= 0 && index > 1) {
          this.mesesRestantes = index % 12;
          interesB = balance * (intereses / 12);
          interesTotal = interesB + interesTotal;
          principalTabla = this.principal - interesB;
          principalTotal = principalTabla + principalTotal;
          balance = balance - principalTabla;
          acumuladoPrincipal += principalTabla;
          acumuladoInteres += interesB;
          this.tablaMensual.push({
            mes: index,
            principal: principalTabla.toFixed(2),
            principal_total: principalTotal.toFixed(2),
            interes: interesB.toFixed(2),
            interes_total: interesTotal.toFixed(2),
            balance: balance.toFixed(2)
          });
        }
        if (frequencyCounter === 12) {
          yearsCounter++;
          if (balance > -1) {
            this.tablaAnualizada.push({
              year: yearsCounter,
              principal: acumuladoPrincipal.toFixed(2),
              principal_total: principalTotal.toFixed(2),
              interes: acumuladoInteres.toFixed(2),
              interes_total: interesTotal.toFixed(2),
              balance: balance.toFixed(2)
            });
            frequencyCounter = 0;
            this.plazo = yearsCounter;
            this.chartAmortizacionData.push({
              "date": actYear.toString(),
              "Principal": acumuladoPrincipal.toFixed(2),
              "Interés": acumuladoInteres.toFixed(2),
              "Balance": balance.toFixed(2),
            });
            this.chartBalanceData.push({
              "date": actYear.toString(),
              "Principal": principalTotal.toFixed(2),
              "Interés": interesTotal.toFixed(2),
              "Balance": balance.toFixed(2),
            });
            actYear++;
          }
          acumuladoPrincipal = 0;
          acumuladoInteres = 0;
        }
        this.interesAhorrado = interesTotalSPA - interesTotal;
        frequencyCounter++;
      }
      if (this.pagoAdicional > 0) {
        this.tablaAnualizada.push({
          year: yearsCounter,
          principal: principalTabla.toFixed(2),
          principal_total: principalTotal.toFixed(2),
          interes: interesB.toFixed(2),
          interes_total: interesTotal.toFixed(2),
          balance: balance.toFixed(2)
        });
      }
      this.costoTotal = interesTotal + this.prestamo;
      this.interesTotal = interesTotal;
      this.chartAmortizacion.data = this.chartAmortizacionData;
      this.chartBalance.data = this.chartBalanceData;

      //PIE
      this.chart.data = [{
        "categoria": "Principal + Interés",
        "valor": this.principal.toFixed(2),
        "color": "#123B4F",
      },
        {
          "categoria": "Impuestos",
          "valor": this.tax.toFixed(2),
          "color": "#99742A",
        },
        {
          "categoria": "Seguro",
          "valor": this.insurance,
          "color": "#E6AE35",
        },
        {
          "categoria": "HOA",
          "valor": this.hoaRes,
          "color": "#1D5F80",
        },
        {
          "categoria": "PMI",
          "valor": this.pmiRes,
          "color": "#A63838",
        }];
      //PIE
    },


    formattedNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },

  mounted() {
    const textColor = "#808080";


    this.chart = am4core.create("chartdiv", am4charts.PieChart);
    if (this.chart.logo) {
      this.chart.logo.dispose()
    }
    this.chart.data = [{
      "categoria": "Principal + Interés",
      "valor": 0,
      "color": "#123B4F",
    },
      {
        "categoria": "Impuestos",
        "valor": 0,
        "color": "#99742A",
      },
      {
        "categoria": "Seguro",
        "valor": 0,
        "color": "#E6AE35",
      },
      {
        "categoria": "HOA",
        "valor": 0,
        "color": "#1D5F80",
      },
      {
        "categoria": "PMI",
        "valor": 0,
        "color": "#A63838",
      }];
    let pieSeries = this.chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "valor";
    pieSeries.dataFields.category = "categoria";
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.labels.template.text = "{value.percent.formatNumber('#.00')}%";
    pieSeries.slices.template.tooltipText = "[bold, font-size:35px]${valor.formatNumber('#,###.##')}\n[normal]{categoria}[/]";
    pieSeries.slices.template.tooltipX = 0;
    pieSeries.slices.template.tooltipY = 40;
    pieSeries.tooltip.label.textAlign = "middle";
    pieSeries.tooltip.background.filters.clear();
    pieSeries.tooltip.background.pointerLength = 0;
    pieSeries.tooltip.background.strokeOpacity = 0;
    pieSeries.tooltip.label.propertyFields.fill = "color";
    pieSeries.tooltip.background.cornerRadius = 50;
    pieSeries.tooltip.label.minWidth = 150;
    pieSeries.tooltip.label.minHeight = 100;
    pieSeries.tooltip.label.textValign = "middle";
    pieSeries.labels.template.fill = am4core.color(textColor);//this.chart.data.reverse()
    let hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1.08;
    let as = pieSeries.slices.template.states.getKey("active");
    as.properties.shiftRadius = .1;
    // UN SLICE A LA VEZ
    pieSeries.slices.template.events.on("hit", function (ev) {
      let series = ev.target.dataItem.component;
      series.slices.each(function (item) {
        if (item.isActive && item != ev.target) {
          item.isActive = false;
        }
      })
    });
    // LEYENDA
    this.chart.legend = new am4charts.Legend();
    this.chart.legend.labels.template.fill = am4core.color(textColor);
    this.chart.legend.valueLabels.template.fill = am4core.color(textColor);

    this.chart.legend.valueLabels.template.text = "";
    let marker = this.chart.legend.markers.template.children.getIndex(0);
    marker.cornerRadius(15, 15, 15, 15);
    marker.strokeWidth = 2;
    marker.strokeOpacity = 1;
    // ANIAMCION INICIAL
    pieSeries.hiddenState.properties.opacity = 1;
    pieSeries.hiddenState.properties.endAngle = -90;
    pieSeries.hiddenState.properties.startAngle = -90;
    // RESPONSIVE
    this.chart.responsive.enabled = true;
    this.chart.responsive.rules.push({
      relevant: function (target) {
        if (target.pixelWidth <= 500) {
          return true;
        }
        return false;
      },
      state: function (target, stateId) {
        if (target instanceof am4charts.PieSeries) {
          var state = target.states.create(stateId);
          state.properties.paddingTop = 0;
          state.properties.paddingRight = 0;
          state.properties.paddingBottom = 0;
          state.properties.paddingLeft = 0;

          var labelState = target.labels.template.states.create(stateId);
          labelState.properties.disabled = true;

          var tickState = target.ticks.template.states.create(stateId);
          tickState.properties.disabled = true;
          return state;
        }
        return null;
      }
    });

    //AMORTIZACIONES BARRA
    this.chartAmortizacion = am4core.create("barchartdiv", am4charts.XYChart);
    if (this.chartAmortizacion.logo) {
      this.chartAmortizacion.logo.dispose()
    }
    this.chartAmortizacion.data = [{
      "date": "",
      "principal": 0,
      "interes": 0,
      "balance": 0,
    }];
    // AXIS
    var categoryAxis = this.chartAmortizacion.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "date";
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.minGridDistance = 50;
    categoryAxis.renderer.labels.template.fill = am4core.color(textColor);
    categoryAxis.title.fill = am4core.color(textColor);

    var axisTooltip = categoryAxis.tooltip;
    axisTooltip.background.fill = am4core.color("#000");
    axisTooltip.background.strokeWidth = 0;
    axisTooltip.background.cornerRadius = 5;
    axisTooltip.background.pointerLength = 0;
    axisTooltip.dy = 5;
    axisTooltip.animationDuration = 0;

    var valueAxis = this.chartAmortizacion.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.labels.template.fill = am4core.color(textColor);
    valueAxis.renderer.grid.template.stroke = am4core.color(textColor);
    valueAxis.renderer.line.stroke = am4core.color(textColor);
    valueAxis.numberFormatter.numberFormat = "'$'#,###.##";
    valueAxis.tooltip.disabled = true;

    var valueAxis2 = this.chartAmortizacion.yAxes.push(new am4charts.ValueAxis());
    valueAxis2.renderer.labels.template.fill = am4core.color(textColor);
    valueAxis2.renderer.grid.template.stroke = am4core.color(textColor);
    valueAxis2.renderer.line.stroke = am4core.color(textColor);
    valueAxis2.renderer.opposite = true;
    valueAxis2.renderer.grid.template.disabled = true;
    valueAxis2.renderer.labels.template.disabled = true;
    valueAxis2.tooltip.disabled = true;

    // COLORES
    this.chartAmortizacion.colors.list = [
      am4core.color("#659F6B"),
      am4core.color("#A63838"),
      am4core.color("#E6AE3F"),
    ];


    // PRINCIPAL (antes: BALANCE)
    var series = this.chartAmortizacion.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "Principal";
    series.dataFields.categoryX = "date";
    series.name = "Principal";
    series.tooltipText = "[#fff]{name}: [bold, #fff]{valueY}[/]";
    series.tooltip.background.filters.clear();
    series.tooltip.animationDuration = 0;
    series.columns.template.column.cornerRadiusTopLeft = 5;
    series.columns.template.column.cornerRadiusTopRight = 5;


    // GANANCIA TOTAL (antes: COTRIBUCIONES)
    var series2 = this.chartAmortizacion.series.push(new am4charts.ColumnSeries());
    series2.dataFields.valueY = "Interés";
    series2.dataFields.categoryX = "date";
    series2.name = "Interés";
    series2.tooltipText = "{name}: [bold]{valueY}[/]";
    series2.tooltip.background.filters.clear();
    series2.tooltip.animationDuration = 0;
    //series2.stacked = true;
    series2.columns.template.column.cornerRadiusTopLeft = 5;
    series2.columns.template.column.cornerRadiusTopRight = 5;

    // GANANCIA (nueva serie)
    var series3 = this.chartAmortizacion.series.push(new am4charts.LineSeries());
    series3.dataFields.valueY = "Balance";
    series3.dataFields.categoryX = "date";
    series3.yAxis = valueAxis2;
    series3.name = "Balance";
    series3.strokeWidth = 3;
    series3.tooltipText = "[#000]{name}: [bold, #000]{valueY}[/]";
    series3.strokeWidth = 3;
    series3.tooltip.background.filters.clear();
    series3.tooltip.animationDuration = 0;

    // CURSOR
    this.chartAmortizacion.cursor = new am4charts.XYCursor();
    this.chartAmortizacion.cursor.behavior = "none";
    this.chartAmortizacion.cursor.lineY.disabled = true;
    this.chartAmortizacion.cursor.fullWidthLineX = true;
    this.chartAmortizacion.cursor.xAxis = categoryAxis;
    this.chartAmortizacion.cursor.lineX.strokeOpacity = 0;
    this.chartAmortizacion.cursor.lineX.fill = "#000";
    this.chartAmortizacion.cursor.lineX.fillOpacity = 0.1;

    // LEYENDA
    this.chartAmortizacion.legend = new am4charts.Legend();
    this.chartAmortizacion.legend.labels.template.fill = am4core.color(textColor);
    this.chartAmortizacion.legend.valueLabels.template.fill = am4core.color(textColor);

    // BOTON ZOOM-OUT
    this.chartAmortizacion.zoomOutButton.align = "left";
    this.chartAmortizacion.zoomOutButton.valign = "top";
    this.chartAmortizacion.zoomOutButton.background.defaultState.properties.fill = "#000";
    this.chartAmortizacion.zoomOutButton.background.defaultState.properties.fillOpacity = .2;
    this.chartAmortizacion.zoomOutButton.background.states.getKey("hover").properties.fill = "#000";
    this.chartAmortizacion.zoomOutButton.background.states.getKey("down").properties.fill = "#000";
    this.chartAmortizacion.zoomOutButton.icon.strokeWidth = 2;

    // RESPONSIVE
    this.chartAmortizacion.responsive.enabled = true;
    this.chartAmortizacion.responsive.useDefault = false

    this.chartAmortizacion.responsive.rules.push({
      relevant: function (target) {
        if (target.pixelWidth <= 500) {
          return true;
        }

        return false;
      },
      state: function (target, stateId) {

        if (target instanceof am4charts.Chart) {
          var state = target.states.create(stateId);
          state.properties.paddingTop = 0;
          state.properties.paddingRight = 15;
          state.properties.paddingBottom = 5;
          state.properties.paddingLeft = 15;
          return state;
        }

        if (target instanceof am4core.Scrollbar) {
          state = target.states.create(stateId);
          state.properties.marginBottom = -10;
          return state;
        }

        if (target instanceof am4charts.Legend) {
          state = target.states.create(stateId);
          state.properties.paddingTop = 0;
          state.properties.paddingRight = 0;
          state.properties.paddingBottom = 0;
          state.properties.paddingLeft = 0;
          state.properties.marginLeft = 0;
          return state;
        }

        if (target instanceof am4charts.AxisRendererY) {
          state = target.states.create(stateId);
          state.properties.maxLabelPosition = 1;
          return state;
        }

        if ((target instanceof am4charts.AxisLabel) && (target.parent instanceof am4charts.AxisRendererY)) {
          state = target.states.create(stateId);
          state.properties.dy = -15;
          state.properties.paddingTop = 3;
          state.properties.paddingRight = 5;
          state.properties.paddingBottom = 3;
          state.properties.paddingLeft = 5;
          return state;
        }
        return null;
      }
    });

    //BALANCES BARRA
    this.chartBalance = am4core.create("barchartdivBalance", am4charts.XYChart);
    if (this.chartBalance.logo) {
      this.chartBalance.logo.dispose()
    }
    this.chartBalance.data = [{
      "date": "",
      "principal": 0,
      "interes": 0,
      "balance": 0,
    }];
    // AXIS
    var categoryAxisBalance = this.chartBalance.xAxes.push(new am4charts.CategoryAxis());
    categoryAxisBalance.dataFields.category = "date";
    categoryAxisBalance.renderer.grid.template.disabled = true;
    categoryAxisBalance.renderer.minGridDistance = 50;
    categoryAxisBalance.renderer.labels.template.fill = am4core.color(textColor);
    categoryAxisBalance.title.fill = am4core.color(textColor);

    var axisTooltipBalance = categoryAxisBalance.tooltip;
    axisTooltipBalance.background.fill = am4core.color("#000");
    axisTooltipBalance.background.strokeWidth = 0;
    axisTooltipBalance.background.cornerRadius = 5;
    axisTooltipBalance.background.pointerLength = 0;
    axisTooltipBalance.dy = 5;
    axisTooltipBalance.animationDuration = 0;

    var valueAxisBalance = this.chartBalance.yAxes.push(new am4charts.ValueAxis());
    valueAxisBalance.renderer.labels.template.fill = am4core.color(textColor);
    valueAxisBalance.renderer.grid.template.stroke = am4core.color(textColor);
    valueAxisBalance.renderer.line.stroke = am4core.color(textColor);
    valueAxisBalance.numberFormatter.numberFormat = "'$'#,###.##";
    valueAxisBalance.tooltip.disabled = true;

    var valueAxisBalance2 = this.chartBalance.yAxes.push(new am4charts.ValueAxis());
    valueAxisBalance2.renderer.labels.template.fill = am4core.color(textColor);
    valueAxisBalance2.renderer.grid.template.stroke = am4core.color(textColor);
    valueAxisBalance2.renderer.line.stroke = am4core.color(textColor);
    valueAxisBalance2.renderer.opposite = true;
    valueAxisBalance2.renderer.grid.template.disabled = true;
    valueAxisBalance2.renderer.labels.template.disabled = true;
    valueAxisBalance2.tooltip.disabled = true;

    // COLORES
    this.chartBalance.colors.list = [
      am4core.color("#659F6B"),
      am4core.color("#A63838"),
      am4core.color("#E6AE3F"),
    ];


    // PRINCIPAL (antes: BALANCE)
    var seriesBalance = this.chartBalance.series.push(new am4charts.ColumnSeries());
    seriesBalance.dataFields.valueY = "Principal";
    seriesBalance.dataFields.categoryX = "date";
    seriesBalance.name = "Principal";
    seriesBalance.tooltipText = "[#fff]{name}: [bold, #fff]{valueY}[/]";
    seriesBalance.tooltip.background.filters.clear();
    seriesBalance.columns.template.column.cornerRadiusTopLeft = 5;
    seriesBalance.columns.template.column.cornerRadiusTopRight = 5;
    seriesBalance.tooltip.animationDuration = 0;

    // GANANCIA TOTAL (antes: COTRIBUCIONES)
    var seriesBalance2 = this.chartBalance.series.push(new am4charts.ColumnSeries());
    seriesBalance2.dataFields.valueY = "Interés";
    seriesBalance2.dataFields.categoryX = "date";
    seriesBalance2.name = "Interés";
    seriesBalance2.tooltipText = "{name}: [bold]{valueY}[/]";
    seriesBalance2.tooltip.background.filters.clear();
    seriesBalance2.columns.template.column.cornerRadiusTopLeft = 5;
    seriesBalance2.columns.template.column.cornerRadiusTopRight = 5;
    seriesBalance2.tooltip.animationDuration = 0;

    // GANANCIA (nueva serie)
    var seriesBalance3 = this.chartBalance.series.push(new am4charts.LineSeries());
    seriesBalance3.dataFields.valueY = "Balance";
    seriesBalance3.dataFields.categoryX = "date";
    seriesBalance3.yAxis = valueAxisBalance2;
    seriesBalance3.name = "Balance";
    seriesBalance3.strokeWidth = 3;
    seriesBalance3.tooltipText = "[#000]{name}: [bold, #000]{valueY}[/]";
    seriesBalance3.strokeWidth = 3;
    seriesBalance3.tooltip.background.filters.clear();
    seriesBalance3.tooltip.animationDuration = 0;

    // CURSOR
    this.chartBalance.cursor = new am4charts.XYCursor();
    this.chartBalance.cursor.behavior = "none";
    this.chartBalance.cursor.lineY.disabled = true;
    this.chartBalance.cursor.fullWidthLineX = true;
    this.chartBalance.cursor.xAxis = categoryAxisBalance;
    this.chartBalance.cursor.lineX.strokeOpacity = 0;
    this.chartBalance.cursor.lineX.fill = "#000";
    this.chartBalance.cursor.lineX.fillOpacity = 0.1;

    // LEYENDA
    this.chartBalance.legend = new am4charts.Legend();
    this.chartBalance.legend.labels.template.fill = am4core.color(textColor);
    this.chartBalance.legend.valueLabels.template.fill = am4core.color(textColor);

    // BOTON ZOOM-OUT
    this.chartBalance.zoomOutButton.align = "left";
    this.chartBalance.zoomOutButton.valign = "top";
    this.chartBalance.zoomOutButton.background.defaultState.properties.fill = "#000";
    this.chartBalance.zoomOutButton.background.defaultState.properties.fillOpacity = .2;
    this.chartBalance.zoomOutButton.background.states.getKey("hover").properties.fill = "#000";
    this.chartBalance.zoomOutButton.background.states.getKey("down").properties.fill = "#000";
    this.chartBalance.zoomOutButton.icon.strokeWidth = 2;

    // RESPONSIVE
    this.chartBalance.responsive.enabled = true;
    this.chartBalance.responsive.useDefault = false

    this.chartBalance.responsive.rules.push({
      relevant: function (target) {
        if (target.pixelWidth <= 500) {
          return true;
        }

        return false;
      },
      state: function (target, stateId) {

        if (target instanceof am4charts.Chart) {
          var state = target.states.create(stateId);
          state.properties.paddingTop = 0;
          state.properties.paddingRight = 15;
          state.properties.paddingBottom = 5;
          state.properties.paddingLeft = 15;
          return state;
        }

        if (target instanceof am4core.Scrollbar) {
          state = target.states.create(stateId);
          state.properties.marginBottom = -10;
          return state;
        }

        if (target instanceof am4charts.Legend) {
          state = target.states.create(stateId);
          state.properties.paddingTop = 0;
          state.properties.paddingRight = 0;
          state.properties.paddingBottom = 0;
          state.properties.paddingLeft = 0;
          state.properties.marginLeft = 0;
          return state;
        }

        if (target instanceof am4charts.AxisRendererY) {
          state = target.states.create(stateId);
          state.properties.maxLabelPosition = 1;
          return state;
        }

        if ((target instanceof am4charts.AxisLabel) && (target.parent instanceof am4charts.AxisRendererY)) {
          state = target.states.create(stateId);
          state.properties.dy = -15;
          state.properties.paddingTop = 3;
          state.properties.paddingRight = 5;
          state.properties.paddingBottom = 3;
          state.properties.paddingLeft = 5;
          return state;
        }
        return null;
      }
    });
  },
}
</script>

<style>
input {
  font-family: 'Barlow' !important;
  background-color: #fff !important;
  color: #666 !important;
}

.v-select .v-select__selection-text {
  font-family: 'Barlow';
}

.readonly .v-field__input {
  background-color: #f8f8f8 !important;
}

.readonly input {
  background-color: #f8f8f8 !important;
  display: none !important;
}

.tabtext {
  color: white;
}

.monthly-payment-line {
  width: 40px;
  border-width: 2px !important;
  margin-bottom: 5px !important;
  background-color: rgb(182, 71, 12);
  border-color: rgb(182, 71, 12);
  opacity: initial !important;
  margin-top: 20px;
}

.monthly-payment-line-title {
  width: 40px;
  border-width: 2px !important;
  margin-bottom: 25px !important;
  background-color: rgb(182, 71, 12) !important;
  border-color: rgb(182, 71, 12) !important;
  opacity: initial !important;
  margin-top: 20px !important;
}

.monthly-payment-title {
  text-transform: uppercase !important;
  font-weight: bold;
  color: rgb(182, 71, 12) !important;
  font-size: 18px;
  margin-bottom: 20px !important;
}

.titlepie {
  text-transform: uppercase !important;
  margin-bottom: -20px;
  font-family: "Barlow", !important;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 2rem;
  color: #666 !important;
  padding: 0px !important;
}

.monthly-payment-mount {
  font-family: "Barlow", !important;
  font-weight: 700 !important;
  font-size: 40px;
  color: #666 !important;
}

.calculator-investment {
  line-height: 0.5em;
}

.chartWrapper {
  width: 100%;
  height: 500px;
}

.v-table table tr:hover {
  background-color: #999 !important;
  color: #fff !important;
}

.v-container {
  max-width: 100% !important;
  margin: auto !important;
  padding: auto !important;
}

.v-tooltip span {
  font-size: 17px;
}

.col-style {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

.v-tab__slider {
  height: 6px !important;
}

.v-field__input {
  max-height: 44px !important;
}
</style>

<style>
.result-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 18px;
  border-bottom: 1px solid #e0e0e0;
}

.result-label {
  padding-top: 8px !important;
  font-weight: bold;
}

.result-value {
  font-weight: bold;
  font-size: 28px;
}

.v-label {
  color: #808080 !important;
}

.v-text-field {
  color: #999999 !important;
}

.v-text-field__prefix {
  margin-top: 0 !important;
  color: #999999 !important;
  background-color: rgba(187, 187, 187, 0.15) !important;
}

.v-text-field__suffix {
  margin-top: 0 !important;
  color: #999999 !important;
  background-color: rgba(187, 187, 187, 0.15) !important;
}

.v-text-field .v-field__input {
  background-color: rgba(187, 187, 187, 0.15) !important;
}

.v-text-field .v-field__input,
.v-select .v-field__input {
  background-color: rgba(187, 187, 187, 0.15) !important;
}

.v-input__details {
  min-height: 10px !important;
}
</style>

<style scoped>

* {
  font-family: 'Montserrat', sans-serif;
}

/* 🔹 Fondo transparente */
.v-application,
.v-main,
.v-container {
  background: transparent !important;
}


::v-deep(.v-application) {
  background: transparent !important;
}

::v-deep(.v-main) {
  background: transparent !important;
}

/* 🔹 Textos en gris */
.v-application,
.result-item,
.result-label,
.result-value,
.tab-text,
h1,
h2,
h3,
p,
span {
  color: #7c7c7c !important;
}

/* 🔹 Inputs y selects con texto y bordes en gris */
::v-deep(.v-input__control) {
  background-color: transparent !important;
}

::v-deep(.v-label) {
  color: #808080 !important;
}

/* 🔹 Placeholder en gris */
::v-deep(.v-input input::placeholder) {
  color: #888 !important;
}

/* 🔹 Tablas con bordes y texto en gris */
::v-deep(.v-table) {
  background-color: transparent !important;
  border-color: #666 !important;
}

::v-deep(.v-table thead th),
::v-deep(.v-table tbody td) {
  color: #b0b0b0 !important;
  border-bottom: 1px solid #666 !important;
}

/* 🔹 Cambios en switch (Dark Mode) */
::v-deep(.v-switch .v-input__control) {
  background-color: transparent !important;
  border: 1px solid #666 !important;
}

::v-deep(.v-switch .v-input__control .v-label) {
  color: #b0b0b0 !important;
}

/* 🔹 Botones con bordes y texto en gris */
::v-deep(.v-btn) {
  color: #b0b0b0 !important;
}

/* 🔹 Divider en gris */
.v-divider {
  background-color: #666 !important;
}

/* 🔹 Hover en filas de tablas */
::v-deep(.v-table tbody tr:hover) {
  background: transparent !important;
}

.header-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.title-line {
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
}

</style>